import { render, staticRenderFns } from "./outPut.vue?vue&type=template&id=b96a18fc&"
import script from "./outPut.vue?vue&type=script&lang=js&"
export * from "./outPut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports